import CarouselNavButtonItem from './CarouselNavButtonItem';
import { CarouselNavButtonsProps } from './carousel-nav-buttons-props.interface';
import classNames from 'classnames';
import React from 'react';

const CarouselNavButtons: React.FC<CarouselNavButtonsProps> = ({
  onPrev,
  onNext,
  isPrevDisabled = false,
  isNextDisabled = false,
  prevAriaLabel = 'Previous',
  nextAriaLabel = 'Next',
  className,
  variant = 'bolder',
}) => {
  return (
    <div className={classNames('flex items-center gap-2', className)}>
      <CarouselNavButtonItem
        direction="left"
        disabled={isPrevDisabled}
        ariaLabel={prevAriaLabel}
        onClick={onPrev}
        variant={variant}
      />
      <CarouselNavButtonItem
        direction="right"
        disabled={isNextDisabled}
        ariaLabel={nextAriaLabel}
        onClick={onNext}
        variant={variant}
      />
    </div>
  );
};

export default CarouselNavButtons;
